import CryptoJS from "crypto-js";

export const generateHmac = (plainText, secretKey) => {
  return CryptoJS.HmacSHA256(plainText, secretKey).toString();
};
